/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { Testimonial, InstagramReel, YouTubeVideo, Tweet } from '../types';
import { CDN_URLS, OCI_FOLDERS } from '../config';

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    nameKey: 'testimonial_name_1',
    locationKey: 'testimonial_location_paris',
    quoteKey: 'testimonial_quote_1',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'portfolioPage_service_personalStyling_title'
  },
  {
    id: 'testimonial-2',
    nameKey: 'testimonial_name_2',
    locationKey: 'testimonial_location_milan',
    quoteKey: 'testimonial_quote_2',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'portfolioPage_service_premiumInPerson_title'
  },
  {
    id: 'testimonial-3',
    nameKey: 'testimonial_name_3',
    locationKey: 'testimonial_location_london',
    quoteKey: 'testimonial_quote_3',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'portfolioPage_service_wardrobeCuration_title'
  },
  {
    id: 'testimonial-4',
    nameKey: 'testimonial_name_4',
    locationKey: 'testimonial_location_shanghai',
    quoteKey: 'testimonial_quote_4',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'portfolioPage_service_eventStyling_title'
  },
  {
    id: 'testimonial-5',
    nameKey: 'testimonial_name_5',
    locationKey: 'testimonial_location_tokyo',
    quoteKey: 'testimonial_quote_5',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'profilePage_stylePersona_title'
  },
  {
    id: 'testimonial-6',
    nameKey: 'testimonial_name_6',
    locationKey: 'testimonial_location_montreal',
    quoteKey: 'testimonial_quote_6',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'portfolioPage_service_eventStyling_title'
  },
  {
    id: 'testimonial-7',
    nameKey: 'testimonial_name_7',
    locationKey: 'testimonial_location_barcelona',
    quoteKey: 'testimonial_quote_7',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1527980965255-d3b416303d12?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'stylingAdvisorPage_planSectionTitle'
  },
  {
    id: 'testimonial-8',
    nameKey: 'testimonial_name_8',
    locationKey: 'testimonial_location_dubai',
    quoteKey: 'testimonial_quote_8',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1531123897727-8f129e1688ce?w=150&h=150&fit=crop&crop=faces`,
    serviceKey: 'nav_findSimilar'
  }
];

export const instagramReels: InstagramReel[] = [
  {
    id: 'reel-1',
    thumbnailUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/casual_city_1.png`,
    videoUrl: 'https://www.instagram.com/reel/C7Z-jXugHis/',
    author: '@styleDiaries',
    avatarUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/casual_city_1.png`,
    caption: 'Summer vibes with our new linen collection! ☀️',
    captionKey: 'reel_1_caption'
  },
  {
    id: 'reel-2',
    thumbnailUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}manner/manner_elegant_casual.png`,
    videoUrl: 'https://www.instagram.com/reel/DT7j1EQAvIJ/',
    author: '@glamGuru',
    avatarUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}manner/manner_1_elegant_.png`,
    caption: 'Get ready for the gala season. ✨',
    captionKey: 'reel_2_caption'
  },
  {
    id: 'reel-3',
    thumbnailUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_bluse_kravte.png`,
    videoUrl: 'https://www.instagram.com/reel/DTLDsU_gi-i/',
    author: '@urbanExplorer',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1527980965255-d3b416303d12?w=100&h=100&fit=crop`,
    caption: 'Street style inspiration from Tokyo. 🇯🇵',
    captionKey: 'reel_3_caption'
  }
];

export const youTubeVideos: YouTubeVideo[] = [
  {
    id: '1',
    titleKey: 'youtube_1_title',
    thumbnailUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Sport/sport_444.jpg`,
    channel: 'Style Theory',
    views: '1.2M',
    publishedKey: 'youtube_1_published'
  },
  {
    id: '2',
    titleKey: 'youtube_2_title',
    thumbnailUrl: `${CDN_URLS.UNSPLASH}photo-1525507119028-ed4c629a60a3?q=80&w=600&auto=format&fit=crop`,
    channel: 'Minimalist Fashion',
    views: '3.4M',
    publishedKey: 'youtube_2_published'
  }
];

export const tweets: Tweet[] = [
  {
    id: '1',
    authorKey: 'tweet_1_author',
    handle: '@ffw_mag',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop`,
    textKey: 'tweet_1_text',
    timestampKey: 'tweet_1_timestamp'
  },
  {
    id: '2',
    authorKey: 'tweet_2_author',
    handle: '@stylescoutdaily',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop`,
    textKey: 'tweet_2_text',
    timestampKey: 'tweet_2_timestamp'
  }
];